var IS_MAP_SENTINEL="@@__IMMUTABLE_MAP__@@";export default function isMap(maybeMap){return!!(maybeMap&&maybeMap[IS_MAP_SENTINEL])}
//# sourceMappingURL=is-immutable-map.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-map-gl/dist/esm/utils/is-immutable-map.js
// module id = 62
// module chunks = 0